app.service('rankingRotator', function (viewPoint) {

	let $self;
	let $box

	function init() {
		$box = $('#ranking-rotator-section');
		$self = $(".ranking-miniatures");
		if ($self.length) {
			initUA();
		}
	}

	function initUA(){

		viewPoint.set({
			element: $box,
			height: 0.6*$box.height(),
			callback: function(){
				UA.interaction('Test SG', 'Sekcja Rankingi - wyswietlenie');
			}
		});

		$box.on('click', '.ranking-miniature-box',function(){
			var index = $(this).index()+1;
			UA.interaction('Test SG', 'Sekcja Rankingi - klikniecia', 'Rotator|'+index);
		});
		$box.on('click', '.ranking-miniature-box .photo',function(){
			var index = $(this).closest('.ranking-miniature-box').index()+1;
			UA.interaction('Test SG', 'Sekcja Rankingi - klikniecia', 'Rotator|Obraz|'+index);
		});
		$box.on('click', '.ranking-miniature-box .ranking-heading',function(){
			var index = $(this).closest('.ranking-miniature-box').index()+1;
			UA.interaction('Test SG', 'Sekcja Rankingi - klikniecia', 'Rotator|Tytul|'+index);
		});
		$box.on('click', '.ranking-miniature-box .author-box',function(){
			var name = $(this).find('.author-name').text().trim();
			UA.interaction('Test SG', 'Sekcja Rankingi - klikniecia', 'Rotator|Autor|'+name);
		});
	}

	return {init};
});
